import React from 'react';
import '../styles/PropertyCardDetail.css';
import { colour, formatterLong, numberFormatter } from '../styles/GlobalStyles';
import { Badge, Button, CompCardMap, CompDetails, Condition, CustomSwiper, Description, Disqualifier, IconButton, PropertyDistance, PropertyIcon, PropertyLinks, PropertyObstructions, Timeline } from './';
import { Bathroom, Bedroom, Chevron, Exit, Image, LotSize, SquareFootage, YearBuilt } from '../assets/icons';
import { formatDaysOnMarket, getFlipDetails, getPriceField, getStatusDotColour, propertyConditionBG, propertyStatusBG, propertyStatusText, propertyTypeFormat, squareFeetToAcres } from '../functions';
import { Calendar03Icon, CarParking01Icon, PoolIcon } from 'hugeicons-react';

function PropertyCardDetail(props) {
    const property = props.property;
    const selected = props.selected;
    const closeDetailedView = props.closeDetailedView;
    const toggleSelectedComp = props.toggleSelectedComp;
    const showScrollableImages = props.showScrollableImages;
    const propertyType = property.propertyAttributes.propertyType;
    const isLoaded = props.isLoaded;
    const subjectProperty = props.subjectProperty;
    const readOnly = props.readOnly;
    const bestComp = props.bestComp;
    const loading = props.loading;
    const clickedCompDescription = props.clickedCompDescription;
    const conditionUpdate = props.conditionUpdate;
    const finalCondition = subjectProperty === true ? null : conditionUpdate.findIndex(e => e.zpid === property.uniqueIds.zillowId) !== -1 ? conditionUpdate[conditionUpdate.findIndex(e => e.zpid === property.uniqueIds.zillowId)].condition : property.compDetails.propertyCondition;
    const price = getPriceField(property) === null ? "Price unavailable" : formatterLong.format(getPriceField(property)).replace(".00", "");
    const flipDetails = subjectProperty === true ? null : getFlipDetails(property);
    const flipStatus = flipDetails === null ? null : flipDetails.flipStatus;
    const flipBGColour = flipDetails === null ? null : flipDetails.flipBGColour;
    const flipDescription = flipDetails === null ? null : flipDetails.flipDescription;
    const flipDotcolour = flipDetails === null ? null : flipDetails.flipDotcolour;
    const date = property.listingDetails.listingStatus === "for_sale" ? formatDaysOnMarket(property.listingDetails.saleListingDate) : formatDaysOnMarket(property.listingDetails.soldListingDate);

    const propertyDetails = [
        {
            label: propertyTypeFormat(propertyType),
            icon: <PropertyIcon propertyType={propertyType} fill={colour.gray04} className="" size={14} />
        },
        {
            label: `${property.propertyAttributes.bedrooms} beds`,
            icon: <Bedroom className="" size={14} fill={colour.gray04} />
        },
        {
            label: `${property.propertyAttributes.bathrooms} baths`,
            icon: <Bathroom className="" size={14} fill={colour.gray04} />
        },
        {
            label: `${numberFormatter.format(property.propertyAttributes.livingSquareFootage)} sqft`,
            icon: <SquareFootage fill={colour.gray04} className="" />
        },
        {
            label: `Built ${property.propertyAttributes.yearBuilt}`,
            icon: <YearBuilt fill={colour.gray04} className="" />
        },
        {
            label: `${squareFeetToAcres(property.propertyAttributes.lotSquareFootage)}`,
            icon: <LotSize fill={colour.gray04} className="" />
        },
        {
            label: property.propertyAttributes.garage === true ? "Garage" : null,
            icon: <CarParking01Icon size={16} color={colour.gray05} />
        },
        {
            label: property.propertyAttributes.pool === true ? "Pool" : null,
            icon: <PoolIcon size={16} color={colour.gray05} />
        }
    ];
    
    return (
        <div className="property-card-detail-outer-container">
            <div className="property-card-detail-exit-container">
                 <IconButton
                    size="medium"
                    icon={<Exit fill={colour.gray06} className="" size={16} clickFunc={() => null} />}
                    disabled={false}
                    clickFunc={() => closeDetailedView(false)}
                    standardIcon={false}
                    background={true}
                    bgType={"white"}
                    contextTooltip={false}
                    contextTooltipBG={null}
                    contextTooltipText={null}
                    customClass={null}
                />
            </div>
            <div className="property-card-detail-heading-container">
                <h2 className="heading-large-bold colour-primary">
                    {price}
                </h2>
                <span className="body-regular colour-secondary block-text">
                    {property.addressDetails.streetAddress}, {property.addressDetails.city}, {property.addressDetails.state} {property.addressDetails.postalCode}
                </span>
                <PropertyLinks
                    property={property}
                    darkMode={false}
                />
            </div>
            <div className="property-card-detail-body-container">
                <div className="property-card-detail-images-container">
                    {
                        property.listingDetails.mlsPhotoUrls === null || property.listingDetails.mlsPhotoUrls.length === 0 ?
                        <div 
                            className="medium-comp-card-no-image-container"
                        >
                            <Image
                                className="medium-comp-card-no-image-element"
                                fill={colour.gray05}
                            />
                            <span className="label-regular colour-secondary block-text text-align-center">
                                No image
                            </span>
                        </div>
                        :
                        property.listingDetails.mlsPhotoUrls.length === 1 ?
                        <div 
                            className="medium-comp-card-single-image-container"
                            style={{ backgroundImage: `url(${property.listingDetails.mlsPhotoUrls[0]})` }}
                        >
                        </div>
                        :
                        <CustomSwiper
                            images={property.listingDetails.mlsPhotoUrls}
                            imageLimit={100}
                            title=""
                            arrowClicked={null}
                            imageClick={() => showScrollableImages(property)}
                        />
                    }
                </div>
                <div className="property-card-detail-info-container">
                    {
                        propertyDetails.map((item, index) =>
                            item.label !== null &&
                            <div 
                                className="property-card-detail-element"
                                key={index}
                            >
                                {item.icon}
                                <span className="body-regular colour-primary">
                                    {item.label}
                                </span>
                            </div>
                        )
                    }
                </div>
                <div className="property-card-detail-badges-row">
                    <Badge
                        bgColour={propertyStatusBG(property, false)}
                        text={propertyStatusText(property)}
                        statusDot={true}
                        statusDotColour={getStatusDotColour(property)}
                        textClass="body-semibold colour-primary"
                        icon={null}
                        tooltip={false}
                        tooltipBody={null}
                        tooltipPosition={null}
                        iconLeft={false}
                    />
                    <div className="relative-container">
                        <Badge
                            bgColour={flipBGColour}
                            text={flipStatus}
                            statusDot={true}
                            statusDotColour={flipDotcolour}
                            textClass="body-semibold colour-primary"
                            icon={null}
                            tooltip={true}
                            tooltipBody={flipDescription}
                            tooltipPosition={"top"}
                            iconLeft={false}
                        />
                    </div>
                </div>
                <div className="property-card-detail-date-container">
                    <Calendar03Icon 
                        color={colour.gray04} 
                        className="" 
                        size={16} 
                    />
                    <span className="body-regular colour-primary">
                        {property.listingDetails.listingStatus === "for_sale" ? "Listed " : "Sold "}
                        <span className="body-bold">
                            {date}
                        </span>
                    </span>
                </div>
                <div className="property-card-detail-grey-divider">
                </div>
                <Condition
                    label={finalCondition}
                    iconBG={propertyConditionBG(finalCondition, false)}
                    darkMode={false}
                />
                {
                    property.listingDetails.listingDescription !== null &&
                    <Description
                        property={property}
                    />
                }
                <div className="property-card-detail-grey-divider">
                </div>
                {
                    property.compDetails.arvGeneratedNotes !== undefined && property.compDetails.arvGeneratedNotes !== false &&
                    <CompDetails
                        details={property.compDetails.arvGeneratedNotes.updates}
                    />
                }
                {
                    property.compDetails.arvGeneratedNotes !== undefined && property.compDetails.arvGeneratedNotes !== false &&
                    <div className="property-card-detail-grey-divider">
                    </div>
                }
                <div className="property-card-detail-map-container">
                    <PropertyDistance
                        property={property}
                    />
                    <PropertyObstructions
                        property={property}
                    />
                    <CompCardMap
                        isMapLoaded={isLoaded}
                        comp={property}
                        subjectProperty={subjectProperty}
                        isMapActive={true}
                        bestComp={bestComp}
                    />
                </div>
                <div className="property-card-detail-grey-divider">
                </div>
                {
                    property.compDetails.arvPriceHistory !== null &&
                    <Timeline
                        data={property.compDetails.arvPriceHistory}
                        forSale={property.listingDetails.listingStatus === "for_sale" ? true : false}
                    />
                }
                {
                    bestComp === false && (clickedCompDescription !== null || loading === true) &&
                    <Disqualifier
                        text={clickedCompDescription}
                        loading={false}
                        key={clickedCompDescription}
                    />
                }
            </div>
            <div className="property-card-detail-buttons-container">
                <div 
                    className="property-card-detail-cancel-button text-button"
                    onClick={() => closeDetailedView()}
                >
                    <Chevron
                        fill={colour.gray06}
                        className="reverse"
                    />
                    <span className="body-regular text-link">
                        Back
                    </span>
                </div>
                {
                    readOnly === false &&
                    <div className="">
                        <Button
                            buttonType={selected === true ? "light-button" : "primary-button"}
                            size="large"
                            text={selected === true ? "Remove" : "Keep"}
                            cta={() => toggleSelectedComp(property)}
                            disabled={false}
                            leftIcon={null}
                            leftIconClass=""
                            rightIcon={null}
                            rightIconClass=""
                            alt=""
                            standardIcon={false}
                            badge={false}
                            badgeVal={null}
                            badgeBG={null}
                            buttonRef={null}
                            spinner={false}
                        />
                    </div>
                }
            </div>
        </div>
    )
};

export default PropertyCardDetail;